import ActionTypes from '../Actions/ActionTypes';

let initialState = {
    yardSales: [],
    yardSalesPagination: null,

    yardSaleDetails: {},
};

const YardsaleReducer = (state = initialState, action) => {
    switch (action.type) {

        case ActionTypes.GET_YARDSALES:
            state = {
                ...state,
                yardSales: action.payload?.data,
                yardSalesPagination: action.payload,
            };
            break;

        case ActionTypes.CLEAR_YARDSALES:
            state = {
                ...state,
                yardSales: [],
                yardSalesPagination: null,
            };
            break;

        case ActionTypes.GET_YARDSALE_DETAILS:
            state = {
                ...state,
                yardSaleDetails: action.payload,
            };
            break;

        case ActionTypes.CLEAR_YARDSALE_DETAILS:
            state = {
                ...state,
                yardSaleDetails: {},
            };
            break;


        case ActionTypes.DEACTIVATE_YARDSALE:
            const ex_yardsales = [...state.yardSales];
            let index = state.yardSales.findIndex(item => item.id === action.payload.id);
            let updatedYardsale = { ...state.yardSales[index], status: 'cancelled' };
            ex_yardsales.splice(index, 1, updatedYardsale);
            state = {
                ...state,
                yardSales: ex_yardsales,
                yardSalesPagination: state.yardSalesPagination,
            };
            break;



        default:
            break;
    }
    return state;
};

export default YardsaleReducer;
